module.exports = __webpack_public_path__ + "img/cashierPay.f7e37c95.png";